import React, { lazy } from 'react';
import { connect } from 'react-redux';

import { withAITracking } from 'react-appinsights';

import { IContextReducer } from '../../reducers/contextReducer';
import { IProfileReducer } from '../../reducers/profileReducer';
import { IConfigReducer } from '../../reducers/configReducer';
import * as companyActions from '../../actions/companyActions';
import * as profileActions from '../../actions/profileActions';
import { IState } from '../../reducers/index';
import { redirectToLogin } from '../../tools/authTools';
import { MainWrapper } from '../Common/MainWrapper/MainWrapper';
import lazyBlock from '../../tools/lazyBlock';
import { ESpinnerSize, Spinner } from '../Common/Spinner/Spinner';
import withRouter, { RouterProps } from '../../tools/withRouterTool';
import { Layout } from '../Layout/Layout';
import { isSogeInstance } from '../../tools/runtimeInstance';

// tslint:disable-next-line: no-var-requires
const { reactAI } = require('react-appinsights');

const homeContainer = {
    default: lazyBlock(lazy(() => import('./DefaultContainer'))),
    soge: lazyBlock(lazy(() => import('./SogeContainer')))
};

type HomeContainerProps = IConfigReducer & IContextReducer & IProfileReducer
    & typeof companyActions
    & typeof profileActions
    & RouterProps;

export class Component extends React.Component<HomeContainerProps> {
    componentDidMount() {
        const { isLoggedIn } = this.props;
        if (!isLoggedIn) {
            redirectToLogin();
        }
    }

    componentWillMount() {
        reactAI?.setContext({ CorrelationId: `${this.props.currentUserProfile ? this.props.currentUserProfile.id : ''}`, ComponentName: 'Home', url: location.href });
    }

    render() {
        const { pageContext, contextOrganizations, organizationsLoaded } = this.props;
        const params = new URLSearchParams(window.location.search);
        const Home = homeContainer[isSogeInstance() ? 'soge' : 'default'] as any;

    return (
            <Layout>
                {(!pageContext?.user && !organizationsLoaded && contextOrganizations?.ids?.length === 0) ? (
                    <div>
                        <Spinner size={ESpinnerSize.MEDIUM} />
                    </div>
                ) : (
                    <MainWrapper hideProfileSummar={isSogeInstance()} fullWidth>
                        {!!Home && organizationsLoaded && (
                            <Home
                                companyUrlName={params.get('organization')}
                                location={this.props.router.location}
                            />
                        )}
                    </MainWrapper>
                )}
            </Layout>
        );
    }
}

export default withRouter(connect(
    (state: IState) => ({
        ...state.context,
        ...state.profile,
        ...state.config
    }), {
    ...companyActions,
    ...profileActions
}
)(withAITracking(Component)));
